import React from 'react';
import { usePWAInstall } from '../hooks/usePWAInstall';
import { useTranslation } from 'react-i18next';

export const PWAInstallPrompt: React.FC = () => {
  const { isInstallable, isDismissed, promptInstall, dismissPrompt } = usePWAInstall();
  const { t } = useTranslation();

  if (!isInstallable || isDismissed) return null;

  const handleInstall = async () => {
    const res = await promptInstall();
    if (res === 'ios_instructions') {
        alert(t('install.iosInstructions'));
    }
  };

  return (
    <div className="fixed bottom-4 left-4 right-4 md:hidden bg-white p-4 rounded-xl shadow-2xl border border-gray-200 z-[9999] flex items-center justify-between gap-4">
      <div className="flex items-center gap-3">
        <div className="w-10 h-10 bg-red-600 rounded-lg flex items-center justify-center text-white font-black italic shadow shrink-0">C</div>
        <div>
          <p className="text-sm font-bold text-gray-900">{t('install.title')}</p>
          <p className="text-xs text-gray-500">{t('install.desc')}</p>
        </div>
      </div>
      <div className="flex flex-col gap-2 shrink-0">
        <button onClick={handleInstall} className="bg-red-600 text-white px-3 py-1.5 rounded-lg text-xs font-bold shadow hover:bg-red-700 transition-colors">
            {t('install.button')}
        </button>
        <button onClick={dismissPrompt} className="text-gray-400 hover:text-gray-600 text-xs font-medium">
            {t('install.notNow')}
        </button>
      </div>
    </div>
  );
};